import { SchemaControl, type SchemaControlArgs } from '@/modules/common/models/schema/schema-control.ts';
import UiSchemaHost from '@/modules/ui/components/ui/UiSchemaHost.vue';

export class SchemaHost extends SchemaControl<never> {
  readonly component = UiSchemaHost;

  constructor(args: SchemaControlArgs) {
    super(args);
  }
}
